import { studentNumberGetApi } from "../../api/student/studentNumberGetApi"

export async function studentNumberGetService(token: string) {
	return await studentNumberGetApi(token)
}
